import clsx from 'clsx';
import React from 'react';

import useEventTracking from '@hooks/useEventTracking';
import { Theme } from '@interfaces/global';
import { new_session_path } from '@routes';
import { ClickTarget, click } from '@tracking';

import Button from '../../Button';

interface SignInOptionProps {
  className?: string;
  theme: Theme;
}

const SignInOption = ({ className, theme }: SignInOptionProps) => {
  const { trackEvent } = useEventTracking();

  return (
    <div
      className={clsx(className, {
        'text-grayscale-beige': theme === Theme.Dark,
        'text-grayscale-gray': theme === Theme.Light,
      })}
    >
      <span className="opacity-50">Already a subscriber? </span>
      <Button
        className={clsx(
          'font-suisse-screen text-disclosure-sm text-overline-sm underline underline-offset-4 opacity-50 transition-colors hover:border-primary-magenta hover:text-primary-magenta hover:opacity-100 focus:border-primary-magenta focus:text-primary-magenta',
          {
            'text-grayscale-beige': theme === Theme.Dark,
            'text-grayscale-gray': theme === Theme.Light,
          }
        )}
        as="link"
        href={new_session_path()}
        onClickCapture={() => trackEvent(click({ clickTarget: ClickTarget.SignIn }))}
      >
        Sign in
      </Button>
    </div>
  );
};

export default SignInOption;
